import {
    ProofOfSatoshiInput,
    ProofOfSatoshiParagraph, ProofOfSatoshiReceiver,
    ProofOfSatoshiSpan
} from "../ProofOfSatoshiElement";

export const SATOSHI_SPAN_TYPE = (<ProofOfSatoshiSpan/>).type;
export const SATOSHI_INPUT_TYPE = (<ProofOfSatoshiInput/>).type;
export const SATOSHI_PARAGRAPH = (<ProofOfSatoshiParagraph/>).type;
export const SATOSHI_RECEIVER = (<ProofOfSatoshiReceiver/>).type;